import { create } from "zustand";
import { persist } from "zustand/middleware";

interface FortisPaymentForm {
  [key: string]: unknown;
}

interface FortisStatementInfo {
  [key: string]: unknown;
}

interface BillingState {
  currentBillingPageView: string;
  balanceDue: number;
  taskStatement: unknown | null;
  fortisPaymentForm: FortisPaymentForm | null;
  fortisStatementInfo: FortisStatementInfo | null;
  fortisPaymentViaUrl: string | null;
  setBillingCurrentPage: (payload: string) => void;
  setBillingBalanceDue: (payload: number) => void;
  setBillingStatementTask: (payload: unknown) => void;
  setFortisPaymentForm: (payload: FortisPaymentForm | null) => void;
  setFortisStatementInfo: (payload: FortisStatementInfo | null) => void;
  setFortisPaymentUrl: (payload: string | null) => void;
}

export const useBillingStore = create<BillingState>()(
  persist(
    (set) => ({
      currentBillingPageView: "BillingDefault",
      balanceDue: 0,
      taskStatement: null,
      fortisPaymentForm: null,
      fortisStatementInfo: null,
      fortisPaymentViaUrl: null,
      setBillingCurrentPage: (payload) =>
        set({ currentBillingPageView: payload }),
      setBillingBalanceDue: (payload) => set({ balanceDue: payload }),
      setBillingStatementTask: (payload) => set({ taskStatement: payload }),
      setFortisPaymentForm: (payload) => set({ fortisPaymentForm: payload }),
      setFortisStatementInfo: (payload) =>
        set({ fortisStatementInfo: payload }),
      setFortisPaymentUrl: (payload) => set({ fortisPaymentViaUrl: payload }),
    }),
    { name: "portal-billing" }
  )
);
